import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

import { GlobalNotification } from '@common/types';

@Injectable({
  providedIn: 'root',
})
export class GlobalNotificationService {
  private notifications = new BehaviorSubject<GlobalNotification[]>([]);
  notifications$: Observable<GlobalNotification[]> = this.notifications.asObservable();

  constructor() {}

  /**
   * Shows a new notification.
   * @param options - The notification configuration.
   */
  show(options: Omit<GlobalNotification, 'id'>): void {
    const newNotification: GlobalNotification = {
      id: this.generateId(),
      message: options.message,
      type: options.type || 'info',
      title: options.title,
      duration: options.duration || 5000, // Default to 5 seconds
      position: options.position || 'bottom-right',
    };

    // Add the new notification to the array
    const currentNotifications = this.notifications.getValue();
    this.notifications.next([...currentNotifications, newNotification]);

    // Set a timeout to automatically remove the notification
    setTimeout(() => {
      this.remove(newNotification.id);
    }, newNotification.duration);
  }

  /**
   * Removes a notification by its ID.
   * @param id - The ID of the notification to remove.
   */
  public remove(id: string): void {
    const updatedNotifications = this.notifications.getValue().filter((n) => n.id !== id);
    this.notifications.next(updatedNotifications);
  }

  private generateId(): string {
    return `notif_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  }
}
